import styled from 'styled-components';
import * as themeStyled from 'react-tabtab/lib/themes/bulma';

let { TabList, ActionButton, Tab, Panel } = themeStyled;

TabList = styled(TabList)`
    background-color: transparent
    &:hover {
        color: white;
    }
`;

Tab = styled(Tab)`
    border-left: solid 1px rgba(72, 94, 144, 0.16);
    border-right: solid 1px rgba(72, 94, 144, 0.16);
    border-top: solid 1px rgba(72, 94, 144, 0.16);
    color: white
    &:hover {
        color: white;
    }
`;

ActionButton = styled(ActionButton)`
    font-size: 25px;
    padding: 0px;
    color: white;
    background-color: transparent;
    &:hover {
        background-color: transparent;
    }
`;

Panel = styled(Panel)`
    padding: 0px;
    background-color: transparent
`;

export default {
    TabList: TabList,
    ActionButton: ActionButton,
    Tab: Tab,
    Panel: Panel
}
